import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from "../../../../environments/environment";
import { buildRegionProxyHeaders } from "../../utils/region-proxy";
import { DocumentRequestQuery, DocumentRequestResponse } from "./request.model";

@Injectable()
export class RequestService {
  private http = inject(HttpClient);

  private baseUrl = environment.developmentUrl;

  getRequestsByProductId(
    query: DocumentRequestQuery
  ): Observable<DocumentRequestResponse> {
    // Always call the local API. When a non-local region is selected the
    // X-DU-Proxy-Origin header routes the request through the back-end
    // cross-region proxy.
    return this.http.post<DocumentRequestResponse>(
      `${this.baseUrl}history/requests`,
      query,
      { headers: buildRegionProxyHeaders(query.regionUrl) }
    );
  }
}
